import {checkAndExecute, checkAndExecuteToActionReport} from 'root/api/helpers';

export default function HotelRfpBidBenchmarkRateAPI(api) {
  api.benchmarkRates = {
    getHotelRfpBidBenchmarkRate: bidId => checkAndExecute(
      () => bidId,
      () => api.server.get(`rfps/hotel/bids/benchmark-rates/${bidId}`)),

    setHotelRfpBidBenchmarkRate: (bidId, data) => checkAndExecuteToActionReport(
      () => bidId,
      () => api.server.put(`rfps/hotel/bids/benchmark-rates/${bidId}`, data)),

    fetchBidDetails: bidId => checkAndExecute(
      () => bidId,
      () => api.server.get(`rfps/hotel/bids/benchmark-rates/${bidId}/bid-details`)
    ),

    fetchBidsDetails: bidsIds => checkAndExecute(
      () => bidsIds && bidsIds.length,
      () => api.server.post(`rfps/hotel/bids/benchmark-rates/bid-details`, { bidsIds })
    ),

    getRates: request => checkAndExecute(
      () => request,
      () => api.server.post('rfps/hotel/bids/benchmark-rates/fetch', request)
    )
  }
}
